import React from 'react';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { MdInsertLink } from 'react-icons/md';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import Field from 'legacy/common/components/wysiwyg-form/Field';

const TrackingLinkSchema = Yup.object().shape({
  name: Yup.string()
    .required('Required')
    .max(50, 'Name should not be more than 50 characters')
});

type TrackingLinkFormProps = {
  eventId: string;
  isLoading?: boolean;
  errorMessage?: string;
  onClose: () => void;
  onSubmit: ({ eventId, name }: { eventId: string; name: string }) => void;
};

const TrackingLinkForm: React.FC<TrackingLinkFormProps> = ({
  eventId,
  isLoading = false,
  errorMessage = '',
  onClose,
  onSubmit
}) => (
  <Formik
    initialValues={{
      name: ''
    }}
    onSubmit={(values) => {
      onSubmit({
        eventId,
        name: values.name
      });
    }}
    validationSchema={TrackingLinkSchema}
  >
    {({ submitForm }) => (
      <Modal
        visible
        autoHeight
        onClose={onClose}
        type={ModalType.SMALL}
        shouldStopModalClose={isLoading}
        title="New tracking link"
        icon={<MdInsertLink size={20} />}
        renderFooter={() => (
          <Button
            type={ButtonType.Primary}
            onClick={submitForm}
            loading={isLoading}
          >
            Save tracking link
          </Button>
        )}
      >
        <Form>
          <div className="px-4 pt-4 flex flex-col justify-between">
            <p className="mt-4 text-base font-normal">
              Name your tracking link below to assign tracking info amongst your
              partners.
            </p>

            <div className="mt-4">
              <Field
                id="name"
                name="name"
                label="Name the link"
                placeholder="e.g. Sean's Link"
                disabled={isLoading}
              />
            </div>

            <div className="text-red-500 text-center pb-2">{errorMessage}</div>
          </div>
        </Form>
      </Modal>
    )}
  </Formik>
);

export default TrackingLinkForm;
